/**
 * Created by Florin David on 28/09/2016.
 */
import { createStore } from 'redux'
import env from 'config/env'

import { ActionsPayloadsMap } from 'constants/action-types'

import offlineState from 'scripts/offline-state'
import reducers from 'reducers'
// import throttle from 'lodash.throttle'

// import { extendSession } from 'workers/time-events-worker'

// Create store with initial state

const initialState = offlineState.get()

/* eslint-disable @typescript-eslint/no-explicit-any */

const store = createStore(
  reducers,
  initialState,
  (window as any).__REDUX_DEVTOOLS_EXTENSION__?.(),
)

/* eslint-enable @typescript-eslint/no-explicit-any */

// Listeners

store.subscribe(offlineState.save)

// store.subscribe(throttle(() => extendSession(env.EXPIRATION_TIME_MS), 1000))

// Set globals

export const dispatch = <K extends keyof ActionsPayloadsMap>(
  type: K,
  rest?: ActionsPayloadsMap[K] extends undefined
    ? never
    : ActionsPayloadsMap[K],
): void => {
  const action = { type, payload: rest }
  store.dispatch(action)
}

export const getState = store.getState

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.getState = getState

if (env.NODE_ENV === 'development') {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.getState = getState
}

export default store
